<template>
  <div class="stoke-take" id="stoke-take">
    <div class="header" :style="{backgroundColor:isComing?'#ff3c00':'#fff'}">
      <img src="https://summit-img.geekpark.net/mobile/stoketake-header-dark.svg" v-show="!isComing">
      <img src="https://summit-img.geekpark.net/mobile/stoketake-header-light.svg" v-show="isComing">
    </div>
    <div class="content">
      <p style="margin-top: 5vw">
        极客公园始终致力于以专业的判断力为大众找到最值得关注的科技力量。每届 IF，极客公园通过 5 大奖项评选，梳理过去一年中优秀的科技产品、创新的企业组织以及有影响力的企业家，将他们点亮。
      </p>
      <p>
        来 IF X 现场，为你更深度解读他们背后的不平凡之处。
      </p>
      <div class="awards-container">
        <div class="awards">
          <a style="background: url('https://summit-img.geekpark.net/%E5%A5%96%E9%A1%B9-01.png') 0 0 /cover"
             href="http://ifxawards.geekpark.net/innoawards" target="_blank"></a>
          <a style="background: url('https://summit-img.geekpark.net/%E5%A5%96%E9%A1%B9-02.png') 0 0 /cover"
             href="http://ifxawards.geekpark.net/geekchoice" target="_blank"></a>
          <a style="background: url('https://summit-img.geekpark.net/%E5%A5%96%E9%A1%B9-03.png') 0 0 /cover"
             href="http://ifxawards.geekpark.net/geeks100" target="_blank"></a>
          <a style="background: url('https://summit-img.geekpark.net/%E5%A5%96%E9%A1%B9-04.png') 0 0 /cover"
             href="http://ifxawards.geekpark.net/cool30" target="_blank"></a>
          <a style="background: url('https://summit-img.geekpark.net/%E5%A5%96%E9%A1%B9-05.png') 0 0 /cover"
             href="http://ifxawards.geekpark.net/employer" target="_blank"></a>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'StokeTake',
  data () {
    return {
      isComing: false
    }
  },
  mounted () {
    window.addEventListener('scroll', this.handleScroll)
  },
  methods: {
    getElementTop (element) {
      let actualTop = element.offsetTop
      let current = element.offsetParent

      while (current !== null) {
        actualTop += current.offsetTop
        current = current.offsetParent
      }

      return actualTop
    },
    handleScroll () {
      const scrollHeight = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop
      const stokeTakeTop = this.getElementTop(document.querySelector('#stoke-take'))
      if (scrollHeight > stokeTakeTop - 400) {
        this.isComing = true
      }
    }
  },
  beforeDestroy () {
    window.removeEventListener('scroll', this.handleScroll)
  }
}
</script>

<style scoped lang="less">
  .stoke-take {
    margin-top: 15vw;
  }

  .header {
    box-sizing: border-box;
    width: 90vw;
    margin: 0 auto 10vw auto;
    padding: 8vw 0;
    border-top: 1px solid #000;
    border-bottom: 1px solid #000;
    text-align: left;
    transition: background-color .7s;

    img {
      width: 62vw;
      margin-left: 3vw;
    }
  }

  .content {
    text-align: justify;

    p {
      width: 90vw;
      margin: 0 auto 5vw auto;
      line-height: 1.7;
      letter-spacing: 0.1vw;
      font-size: 4vw;
    }
  }

  .awards-container {
    width: 90vw;
    margin-left: 5vw;
    overflow: auto;

    .awards {
      display: flex;
      justify-content: space-between;
      align-items: stretch;
      width: 195vw;

      > a {
        display: block;
        width: 35vw;
        height: 125vw;
        border: 1px solid #f0f0f0;
        background-color: #979797;

        &:last-of-type {
          margin-right: 4vw;
        }
      }
    }
  }
</style>
